"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuditList = useAuditList;
const swr_1 = __importDefault(require("swr"));
const utils_1 = require("../utils");
const index_1 = require("./index");
/**
 * Calls `audit.list` and returns an SWR response. SWR middleware `laggy` is used to make flipping
 * between pages look better, this is done by keeping previously loaded data while new data is loading.
 * SWR `revalidateOnFocus` option is set to `false`.
 *
 * @param request - request to pass to `auditClient.list`, this is optional, if not set backend will not be called and result will not be returned
 * @param baseUrl - optional base URL
 * @param tokenProvider - optional token provider
 * @param config - custom SWR configuration object, can be used to remove the custom `laggy` middleware
 */
function useAuditList(request, baseUrl, tokenProvider, config) {
    const auditClient = (0, index_1.useAuditClient)(baseUrl, tokenProvider);
    return (0, swr_1.default)(request ? ['/platform/audit/list', request] : null, async ([, request]) => {
        return request ? await auditClient.list(request) : undefined;
    }, config ?? {
        use: [utils_1.laggy],
        revalidateOnFocus: false,
    });
}
